import React from 'react';
import { Group, Text } from '@mantine/core';

export const EmptyList: React.FC<{ text: string }> = ({ text }) => {
  return (
    <Group gap="md" justify={'center'} p="xl">
      <Text>{text}</Text>
    </Group>
  );
};
